import React from 'react';

export default function SantaHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Hat body */}
      <path d="M8 30L20 4L32 30Z" fill="#CC2020" />
      {/* Hat curve */}
      <path d="M20 4C22 8 28 16 30 20" stroke="#AA1818" strokeWidth="1" fill="none" opacity="0.3" />
      {/* White trim */}
      <rect x="5" y="28" width="30" height="6" rx="3" fill="#F5F5F0" />
      {/* Trim texture */}
      <circle cx="10" cy="31" r="1.5" fill="white" opacity="0.5" />
      <circle cx="16" cy="31" r="1.5" fill="white" opacity="0.5" />
      <circle cx="22" cy="31" r="1.5" fill="white" opacity="0.5" />
      <circle cx="28" cy="31" r="1.5" fill="white" opacity="0.5" />
      {/* Pompom */}
      <circle cx="20" cy="4" r="4" fill="#F5F5F0" />
      <circle cx="19" cy="3" r="1.5" fill="white" opacity="0.5" />
    </svg>
  );
}
